// All tunables for the simulation. See docs/GAME_DESIGN_SPEC.md §2.
// Units: world units (1 tile = 16 units). Velocities units/s, accels units/s².

export const TILE = 16;
export const DT = 1 / 60; // fixed timestep — one simulation tick

// Gravity & falling
export const GRAVITY = 900;
export const MAX_FALL_SPEED = 600;

// Horizontal run
export const RUN_ACCEL = 1200;
export const RUN_DECEL = 1600;
export const MAX_RUN_SPEED = 140;

// Jump
export const JUMP_VELOCITY = -300;
export const JUMP_CUTOFF = 0.45; // applied once on jump-release while rising
export const COYOTE_TICKS = 6;
export const JUMP_BUFFER_TICKS = 6;

// Dash
export const DASH_SPEED = 320;
export const DASH_TICKS = 10;
export const DASH_COOLDOWN_TICKS = 36;

// Enemies
export const WALKER_SPEED = 50;

// Power-ups
export const IFRAME_TICKS = 90; // invincibility after armor absorbs a hit (~1.5s)
export const TUNER_STEP = 1.15; // each jump/dash/run tuner pickup multiplies the stat

// Player body
export const PLAYER_W = 12;
export const PLAYER_H = 16;
